import React from "react";
import Footer from "../Footer";
import Navbar from "../Navbar";
import ReactHtmlParser from "react-html-parser";

function ShippingCosts({ posts, homepage }) {
  return (
    <div className="shipping-costs">
      <Navbar posts={homepage} />
      <div className="shipping-div">
        {ReactHtmlParser(posts.content.rendered)}
      </div>
      <Footer />
    </div>
  );
}

export default ShippingCosts;
